module.exports = __webpack_public_path__ + "assets/img/5_1145_big.db1754ff.jpg";